module.exports = __webpack_public_path__ + "img/small-telegram.eee94b5f.svg";